import React from 'react';

import Button, {
  ButtonShape,
  ButtonSize,
  ButtonVariants,
} from '@/components/switchback/Button/Button';

import css from './GalleryCategories.module.css';

interface ITabItem {
  title: string;
  controlsId?: string;
  id?: string;
}

interface IGalleryCategories {
  items: ITabItem[];
  active: number;
  handleChangeFilter: (index: number) => void;
}

const GalleryCategories: React.FC<IGalleryCategories> = ({ items, active, handleChangeFilter }) => {
  const handleButtonClick = (id: number) => () => {
    handleChangeFilter(id);
  };

  return (
    <div className={css.wrapper}>
      {items.map((category, index) => (
        <div key={index}>
          <Button
            className={css.button}
            shape={ButtonShape.rectangle}
            size={ButtonSize.small}
            variant={ButtonVariants[index === active ? 'primaryOutlined' : 'grayOutlined']}
            onClick={handleButtonClick(index)}>
            {category.title}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default GalleryCategories;
